
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'

import { mapState } from 'vuex'
export default {
name: 'info',
props: [],
components: {
XHeader,
XInput,
Group,
XButton,
Cell,
Swipeout,
SwipeoutItem,
SwipeoutButton
},
data () {
return {
title: this.$route.meta.title,
familyInfo: []
}
},
computed: {
...mapState({
userInfo: state => state.userInfo
})
},
created () {

},
mounted () {
this.getFamilyInfo()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
finish () {
setTimeout(() => {
this.back()
this.$parent.getFamilyInfo()
}, 300)
},

getFamilyInfo () {
this.$vux.loading.show()
let params = {
studentId: this.userInfo.id
}
this.$api.get('/family', params, r => {
this.$vux.loading.hide()
let data = r.data
this.familyInfo = data
})
},
onButtonClick (type, id) {
if (type === 'edit') {
this.toEdit(id)
} else if (type === 'delete') {
this.deleteInfo(id)
}
},
handleEvents (type) {

},
deleteInfo (id) {
this.$vux.loading.show()
let params = {
id: id
}
this.$api.delete('/family', params,
r => {
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'text',
text: '删除成功',
position: 'top',
time: 1000
})
this.getFamilyInfo()

}, err => {
this.$vux.toast.text(err.message, 'top')
})
},
toAdd (id) {
this.$router.push({
name: 'parentsInfoEdit'
})
sessionStorage.setItem('editInfoId', null)
},
toEdit (id) {
this.$router.push({
name: 'parentsInfoEdit'
})
sessionStorage.setItem('editInfoId', id)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/info/parentsInfo.vue